module.exports = __webpack_public_path__ + "img/ico_date.4651068.svg";